import { render, staticRenderFns } from "./appIntegralManagesList.vue?vue&type=template&id=687f380e&"
import script from "./appIntegralManagesList.vue?vue&type=script&lang=js&"
export * from "./appIntegralManagesList.vue?vue&type=script&lang=js&"
import style0 from "./appIntegralManagesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports